// extracted by mini-css-extract-plugin
export default {"authentication":"AuthenticationUpdate_authentication__Lbl-a","content":"AuthenticationUpdate_content__CqJin"};